import React from "react";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";
import { shareUrl } from "@/components/ShareButton";

const XIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden><path d="M18.9 2H22l-7.2 8.2L23 22h-6.5l-5-6.6L5.7 22H2.6l7.7-8.8L1 2h6.6l4.6 6.1L18.9 2Zm-1.1 18h1.7L6.3 3.9H4.5L17.8 20Z" /></svg>;
const FbIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden><path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.8c0-.9.3-1.5 1.6-1.5h1.7V4.4c-.3 0-1.3-.1-2.5-.1-2.5 0-4.1 1.5-4.1 4.2v2.3H7.4V14h2.8v8h3.3Z" /></svg>;
export const PinIcon = () => <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" aria-hidden><path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.2-2 0-2.9l1.3-5.4s-.3-.7-.3-1.6c0-1.5.9-2.6 2-2.6.9 0 1.4.7 1.4 1.5 0 .9-.6 2.3-.9 3.6-.3 1.1.5 2 1.6 2 1.9 0 3.4-2 3.4-5 0-2.6-1.9-4.4-4.5-4.4-3.1 0-4.9 2.3-4.9 4.7 0 .9.4 1.9.8 2.5.1.1.1.2.1.3l-.3 1.2c0 .2-.2.3-.4.2-1.4-.7-2.2-2.7-2.2-4.3 0-3.5 2.5-6.7 7.3-6.7 3.8 0 6.8 2.7 6.8 6.4 0 3.8-2.4 6.9-5.8 6.9-1.1 0-2.2-.6-2.5-1.3l-.7 2.6c-.2 1-.9 2.2-1.4 2.9A10 10 0 1 0 12 2Z" /></svg>;

export function ShareCountBadge({ slug, min = 10 }: { slug: string; min?: number }) {
  const [count, setCount] = React.useState(0);
  React.useEffect(() => { api.get(`/products/${slug}/share-count`).then((r) => setCount(r.data.count)).catch(() => {}); }, [slug]);
  if (count < min) return null;
  return <span className="text-xs text-neutral-600 italic" data-testid="pdp-share-count">Shared {count} times this month</span>;
}

type Props = { path: string; title: string; image: string; track: string; testPrefix: string; className?: string };

export function ShareLinks({ path, title, image, track, testPrefix, className = "" }: Props) {
  const url = encodeURIComponent(shareUrl(path));
  const t = encodeURIComponent(title);
  const links: [string, string, React.ReactNode][] = [
    ["x", `https://twitter.com/intent/tweet?url=${url}&text=${t}`, <XIcon />],
    ["facebook", `https://www.facebook.com/sharer/sharer.php?u=${url}`, <FbIcon />],
    ["pinterest", `https://pinterest.com/pin/create/button/?url=${url}&media=${encodeURIComponent(image)}&description=${t}`, <PinIcon />],
    ["email", `mailto:?subject=${t}&body=${url}`, <Mail className="h-5 w-5" strokeWidth={1.5} />],
  ];
  return (
    <div className={className}>
      {links.map(([k, href, icon]) => (
        <a key={k} href={href} onClick={() => api.post(track, { network: k }).catch(() => {})} target={k === "email" ? undefined : "_blank"} rel="noreferrer"
          aria-label={`Share on ${k}`} className="text-neutral-900 hover:text-[var(--c-primary)] transition-colors" data-testid={`${testPrefix}-${k}`}>{icon}</a>
      ))}
    </div>
  );
}
